import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthContext = createContext({
  isLoaded: false,
  isSignedIn: false,
  user: null,
  refresh: async () => {},
  signOut: async () => {},
  getToken: async () => null,
});

export function readCsrfCookie() {
  const match = document.cookie.match(/(?:^|; )eb_csrf=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export function AuthProvider({ children }) {
  const [state, setState] = useState({ isLoaded: false, isSignedIn: false, user: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/me`, { withCredentials: true });
      setState({
        isLoaded: true,
        isSignedIn: true,
        user: { id: data.user_id, email: data.email, primaryEmailAddress: { emailAddress: data.email }, fullName: null, role: data.role },
      });
      return { role: data.role };
    } catch {
      setState({ isLoaded: true, isSignedIn: false, user: null });
      return { role: null };
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signOut = useCallback(async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true, headers: { "X-CSRF-Token": readCsrfCookie() || "" } });
    } catch {
      // logout must always clear local state even if the network call fails
    }
    setState({ isLoaded: true, isSignedIn: false, user: null });
  }, []);

  const value = { ...state, refresh, signOut, getToken: async () => null };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  return useContext(AuthContext);
}
